import React, { Suspense } from 'react';
import Loader from '../../../components/commons/helpers/loader/loader.component';
import './training-secondary.styles.scss';

function NewTrainingFormatLandingPage({
  page: { MainContent, breadCrumbList },
}) {
  const HeroComponent = React.lazy(() =>
    import('./new-training-format-hero-component')
  );
  const ContentComponent = React.lazy(() =>
    import('./new-training-format-content-component')
  );

  return (
    <div className="training training-secondary">
      <Suspense fallback={<Loader />}>
        <HeroComponent
          MainContent={MainContent}
          breadCrumbList={breadCrumbList}
        />
      </Suspense>
      <Suspense fallback={<Loader />}>
        <ContentComponent MainContent={MainContent} />
      </Suspense>
    </div>
  );
}

export default NewTrainingFormatLandingPage;
